// // import React, { useCallback, useEffect, useMemo, useState } from "react";
// // import CustomModal from "../../../../components/modal/CustomModal";
// // import { Table, Tag, Button, Flex, Input, Space, Divider, Empty } from "antd";
// // import api from "../../../../api";
// // import { useToast } from "../../../../components/toast/toast";

// // const TicketModal = ({ visible, onClose, setSelectedTicket }) => {
// //   const toast = useToast();

// //   const [filters, setFilters] = useState({
// //     related_account: "",
// //     description: "",
// //   });
// //   const [rows, setRows] = useState([]);
// //   const [loading, setLoading] = useState(false);

// //   const [page, setPage] = useState(1);
// //   const [pageSize, setPageSize] = useState(10);
// //   const [total, setTotal] = useState(0);

// //   // Хэрэглэгч "Хайх" дарсан эсэх — анх table харагдахгүй
// //   const [hasSearched, setHasSearched] = useState(false);

// //   const hasQuery = useMemo(() => {
// //     const { related_account, description } = filters || {};
// //     return Boolean(
// //       (related_account && related_account.trim()) ||
// //       (description && description.trim()),
// //     );
// //   }, [filters]);

// //   const fetchStatements = useCallback(
// //     async (params) => {
// //       setLoading(true);
// //       try {
// //         const res = await api.get_all_bank_statements(params);
// //         if (res.status === 200) {
// //           setRows(res.data?.data || []);
// //           setTotal(res.data?.total || 0);
// //         } else {
// //           toast(res.data?.message || "Алдаа гарлаа", "error");
// //         }
// //       } catch (e) {
// //         toast(e?.response?.data?.message || "Серверийн алдаа", "error");
// //       } finally {
// //         setLoading(false);
// //       }
// //     },
// //     [toast],
// //   );

// //   const runSearch = useCallback(() => {
// //     if (!hasQuery) {
// //       setHasSearched(true);
// //       setRows([]);
// //       setTotal(0);
// //       return;
// //     }
// //     setHasSearched(true);
// //     fetchStatements({
// //       page,
// //       limit: pageSize,
// //       related_account: filters.related_account || undefined,
// //       description: filters.description || undefined,
// //     });
// //   }, [fetchStatements, filters, hasQuery, page, pageSize]);

// //   // Модал нээгдэх үед төлөвийг цэвэрлэнэ
// //   useEffect(() => {
// //     if (visible) {
// //       setRows([]);
// //       setTotal(0);
// //       setPage(1);
// //       setPageSize(10);
// //       setHasSearched(false);
// //       // filters-ийг хадгалж үлдээх бол доорхи 2 мөрийг комментлоорой
// //       setFilters({ related_account: "", description: "" });
// //     }
// //   }, [visible]);

// //   // Pagination өөрчлөгдвөл дахин хайна (зөвхөн өмнө нь хайлт хийсэн байвал)
// //   useEffect(() => {
// //     if (visible && hasSearched && hasQuery) {
// //       runSearch();
// //     }
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [page, pageSize]);

// //   //   const onFilterChange = (key) => (e) => {
// //   //     const value = e.target.value;
// //   //     setFilters((f) => ({ ...f, [key]: value }));
// //   //   };

// //   const onFilterChange = (key) => (e) => {
// //     const value = e?.target?.value ?? "";
// //     setFilters((prev) => {
// //       const next = { ...prev, [key]: value };
// //       const hasAny =
// //         (next.related_account && next.related_account.trim()) ||
// //         (next.description && next.description.trim());

// //       if (!hasAny) {
// //         setRows([]);
// //         setTotal(0);
// //         setHasSearched(false);
// //         setPage(1);
// //       }
// //       return next;
// //     });
// //   };

// //   const handleSelect = (record) => {
// //     setSelectedTicket?.(record);
// //     onClose?.();
// //   };

// //   const columns = [
// //     {
// //       title: "Данс",
// //       dataIndex: "account_number",
// //       key: "account_number",
// //       width: 160,
// //     },
// //     {
// //       title: "Record ID",
// //       dataIndex: "record_id",
// //       key: "record_id",
// //       ellipsis: true,
// //     },
// //     {
// //       title: "Дүн",
// //       dataIndex: "amount",
// //       key: "amount",
// //       width: 120,
// //       render: (v) => <span>{Number(v).toLocaleString()}₮</span>,
// //     },
// //     {
// //       title: "Гүйлгээний утга",
// //       dataIndex: "description",
// //       key: "description",
// //       ellipsis: true,
// //     },
// //     {
// //       title: "Огноо",
// //       dataIndex: "date_at",
// //       key: "date_at",
// //       width: 180,
// //       render: (d) => new Date(d).toLocaleString(),
// //     },
// //     {
// //       title: "Үйлдэл",
// //       key: "action",
// //       width: 120,
// //       align: "center",
// //       render: (_, record) => (
// //         <Button
// //           type="link"
// //           style={{ fontSize: "12px" }}
// //           onClick={() => handleSelect(record)}
// //         >
// //           Сонгох
// //         </Button>
// //       ),
// //     },
// //   ];

// //   return (
// //     <CustomModal
// //       open={visible}
// //       title="Банкны хуулга сонгох"
// //       onCancel={onClose}
// //       footer={null}
// //       width={900}
// //     >
// //       <Flex vertical gap={12}>
// //         <Space style={{ marginBottom: 8 }} wrap>
// //           <Input
// //             style={{ width: 220 }}
// //             placeholder="Холбогдох данс"
// //             value={filters.related_account}
// //             onChange={onFilterChange("related_account")}
// //             allowClear
// //             onPressEnter={runSearch}
// //           />
// //           <Divider type="vertical" />
// //           <Input
// //             style={{ width: 220 }}
// //             placeholder="Гүйлгээний утга"
// //             value={filters.description}
// //             onChange={onFilterChange("description")}
// //             allowClear
// //             onPressEnter={runSearch}
// //           />
// //           <Button
// //             type="primary"
// //             onClick={runSearch}
// //             loading={loading}
// //             disabled={!hasQuery}
// //           >
// //             Хайх
// //           </Button>
// //         </Space>

// //         {/* Хоосон үед “Хайлт хийнэ үү” — table харагдахгүй */}
// //         {!hasSearched && (
// //           <Empty
// //             description="Хайлт хийнэ үү"
// //             image={Empty.PRESENTED_IMAGE_SIMPLE}
// //             style={{ padding: "24px 0" }}
// //           />
// //         )}

// //         {/* Хайлт хийсний дараа л Table үзүүлнэ */}
// //         {hasSearched && (
// //           <Table
// //             rowKey={(r) => `${r.account_number}:${r.record_id}`}
// //             columns={columns}
// //             dataSource={rows}
// //             loading={loading}
// //             pagination={{
// //               current: page,
// //               pageSize,
// //               total,
// //               showSizeChanger: true,
// //               onChange: (p, ps) => {
// //                 setPage(p);
// //                 setPageSize(ps);
// //               },
// //             }}
// //             size="middle"
// //             locale={{
// //               emptyText: hasQuery ? (
// //                 <Empty
// //                   description="Илэрц олдсонгүй"
// //                   image={Empty.PRESENTED_IMAGE_SIMPLE}
// //                 />
// //               ) : (
// //                 <Empty
// //                   description="Хайлт хийнэ үү"
// //                   image={Empty.PRESENTED_IMAGE_SIMPLE}
// //                 />
// //               ),
// //             }}
// //           />
// //         )}
// //       </Flex>
// //     </CustomModal>
// //   );
// // };

// // export default TicketModal;

// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import CustomModal from "../../../../components/modal/CustomModal";
// import { Table, Button, Flex, Space, Divider, Empty } from "antd";
// import api from "../../../../api";
// import { useToast } from "../../../../components/toast/toast";
// import CustomInput from "../../../../components/input/CustomInput";
// import { IconSearch } from "@tabler/icons-react";

// const TicketModal = ({ visible, onClose, setSelectedTicket }) => {
//   const [tickets, setTickets] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [phone, setPhone] = useState("");
//   const [prefix, setPrefix] = useState("");
//   const [bankNumber, setBankNumber] = useState("");
//   const [transactionId, setTransactionId] = useState("");
//   const [dateRange, setDateRange] = useState([null, null]);
//   const [showModal, setShowModal] = useState(false);
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 10,
//     total: 0,
//   });
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     phone: "",
//     ticket_code: "",
//     type: "TICKET",
//   });
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [showDrawer, setShowDrawer] = useState(false);
//   const toast = useToast();

//   const handleChange = (name, value) => {
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const clearHandler = () => {
//     setShowModal(false);
//     setFormData({
//       title: "",
//       description: "",
//       phone: "",
//       ticket_code: "",
//       type: "TICKET",
//     });
//   };

//   const [filters, setFilters] = useState({
//     phone_number: "",
//     ticket_prefix: "",
//     bank_number: "",
//     transaction_id: "",
//   });

//   const [rows, setRows] = useState([]);

//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [total, setTotal] = useState(0);

//   const [hasSearched, setHasSearched] = useState(false);
//   const [lastQuery, setLastQuery] = useState(null); // ✅ сүүлчийн хайлтын params

//   const hasQuery = useMemo(() => {
//     const { phone_number, ticket_prefix, bank_number, transaction_id } =
//       filters;
//     return Boolean(
//       phone_number?.trim() ||
//       ticket_prefix?.trim() ||
//       bank_number?.trim() ||
//       transaction_id?.trim(),
//     );
//   }, [filters]);

//   const fetchTickets = async (
//     paramsFromClear = null,
//     page = 1,
//     pageSize = 10,
//   ) => {
//     setLoading(true);
//     const params = paramsFromClear ?? {
//       ...(phone && { phone_number: phone }),
//       ...(prefix && { ticket_prefix: prefix }),
//       ...(bankNumber && { bank_number: bankNumber }),
//       ...(transactionId && { transaction_id: transactionId }),
//       // date filter:
//       ...(dateRange?.[0] && dateRange?.[1]
//         ? {
//             from_date: dateRange[0].format("YYYY-MM-DD"),
//             to_date: dateRange[1].format("YYYY-MM-DD"),
//           }
//         : {}),
//     };

//     // console.log("fetching with params:", params);
//     const res = await api.get_ticket_list({
//       ...params,
//       page,
//       limit: pageSize,
//     });

//     console.log("tickets res --->", res.data);
//     if (res.status === 200) {
//       setTickets(res.data.data);
//       setPagination((prev) => ({
//         ...prev,
//         current: page,
//         pageSize,
//         total: res.data.total || 0,
//       }));
//     } else {
//       // console.error("Error fetching tickets:", res);
//       toast(res.data?.message || "Алдаа гарлаа", "error");
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     if (pagination) {
//       fetchTickets(null, pagination.current, pagination.pageSize);
//     }
//   }, []);

//   // ✅ modal нээгдэхэд reset
//   useEffect(() => {
//     if (!visible) return;
//     setRows([]);
//     setTotal(0);
//     setPage(1);
//     setPageSize(10);
//     setHasSearched(false);
//     setLastQuery(null);
//     setFilters({
//       phone_number: "",
//       ticket_prefix: "",
//       bank_number: "",
//       transaction_id: "",
//     });
//   }, [visible]);

//   const onFilterChange = (key) => (e) => {
//     const value = e?.target?.value ?? "";
//     setFilters((prev) => ({ ...prev, [key]: value }));
//   };

//   const handleSelect = (record) => {
//     setSelectedTicket?.(record);
//     onClose?.();
//   };

//   const columns = [
//     {
//       title: "Prefix",
//       dataIndex: "ticket_prefix",
//       key: "ticket_prefix",
//       width: 120,
//     },
//     { title: "Ticket ID", dataIndex: "id", key: "id", ellipsis: true },
//     {
//       title: "Утас",
//       dataIndex: "phone_number",
//       key: "phone_number",
//       width: 130,
//     },
//     {
//       title: "Дүн",
//       dataIndex: "amount",
//       key: "amount",
//       width: 120,
//       render: (v) => (v == null ? "-" : `${Number(v).toLocaleString()}₮`),
//     },
//     {
//       title: "Огноо",
//       dataIndex: "created_at",
//       key: "created_at",
//       width: 180,
//       render: (d) => (d ? new Date(d).toLocaleString() : "-"),
//     },
//     {
//       title: "Үйлдэл",
//       key: "action",
//       width: 120,
//       align: "center",
//       render: (_, record) => (
//         <Button
//           type="link"
//           style={{ fontSize: 12 }}
//           onClick={() => handleSelect(record)}
//         >
//           Сонгох
//         </Button>
//       ),
//     },
//   ];

//   return (
//     <CustomModal
//       open={visible}
//       title="Ticket сонгох"
//       onCancel={onClose}
//       footer={null}
//       width={980}
//     >
//       <Flex vertical gap={12}>
//         <Space style={{ marginBottom: 16 }} wrap>
//           <CustomInput
//             placeholder="Утасны дугаар"
//             value={phone}
//             // onChange={(e) => setPhone(e.target.value)}
//             onChange={(e) => {
//               const onlyNums = e.target.value.replace(/\D/g, "");
//               if (onlyNums.length <= 8) setPhone(onlyNums);
//             }}
//             style={{ width: 200 }}
//             maxLength={8}
//             type="number"
//           />
//           <CustomInput
//             placeholder="Сугалааны код (AZ51...)"
//             value={prefix}
//             onChange={(e) => setPrefix(e.target.value)}
//             style={{ width: 200 }}
//           />
//           <CustomInput
//             placeholder="Дансны дугаар"
//             value={bankNumber}
//             onChange={(e) => setBankNumber(e.target.value)}
//             style={{ width: 200 }}
//           />

//           <CustomInput
//             placeholder="ID ..."
//             value={transactionId}
//             onChange={(e) => setTransactionId(e.target.value)}
//             style={{ width: 220 }}
//           />
//           <Button
//             size="large"
//             icon={<IconSearch size={14} />}
//             // onClick={() => fetchTickets()}
//             onClick={() => fetchTickets(null, 1, pagination.pageSize)}
//           >
//             Хайх
//           </Button>
//           <Divider type="vertical" />
//           <Button
//             size="large"
//             onClick={() => {
//               setPhone("");
//               setPrefix("");
//               setBankNumber("");
//               setDateRange([null, null]);
//               setTransactionId("");
//               fetchTickets({});
//             }}
//           >
//             Цэвэрлэх
//           </Button>
//         </Space>

//         {!hasSearched ? (
//           <Empty
//             description="Хайлт хийнэ үү"
//             image={Empty.PRESENTED_IMAGE_SIMPLE}
//             style={{ padding: "24px 0" }}
//           />
//         ) : (
//           <Table
//             rowKey={(r) => r.id}
//             columns={columns}
//             dataSource={tickets}
//             loading={loading}
//             pagination={{
//               current: page,
//               pageSize,
//               total,
//               showSizeChanger: true,
//               onChange: (p, ps) => {
//                 setPage(p);
//                 setPageSize(ps);
//               },
//             }}
//             size="middle"
//             locale={{
//               emptyText: (
//                 <Empty
//                   description={hasQuery ? "Илэрц олдсонгүй" : "Хайлт хийнэ үү"}
//                   image={Empty.PRESENTED_IMAGE_SIMPLE}
//                 />
//               ),
//             }}
//           />
//         )}
//       </Flex>
//     </CustomModal>
//   );
// };

// export default TicketModal;

import React, { useCallback, useEffect, useState } from "react";
import CustomModal from "../../../../components/modal/CustomModal";
import { Table, Button, Flex, Space, Divider, Empty } from "antd";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";
import CustomInput from "../../../../components/input/CustomInput";
import { IconSearch } from "@tabler/icons-react";
import { formatCurrency, formatDateTime } from "../../../../utilities/utils";

const TicketModal = ({ visible, onClose, setSelectedTicket }) => {
  const toast = useToast();

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);

  const [phone, setPhone] = useState("80004002");
  const [prefix, setPrefix] = useState("");
  const [bankNumber, setBankNumber] = useState("");
  const [transactionId, setTransactionId] = useState("");

  const [hasSearched, setHasSearched] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const hasQuery =
    !!phone?.trim() ||
    !!prefix?.trim() ||
    !!bankNumber?.trim() ||
    !!transactionId?.trim();

  const buildParams = useCallback(() => {
    return {
      ...(phone ? { phone_number: phone } : {}),
      ...(prefix ? { ticket_prefix: prefix } : {}),
      ...(bankNumber ? { bank_number: bankNumber } : {}),
      ...(transactionId ? { transaction_id: transactionId } : {}),
    };
  }, [phone, prefix, bankNumber, transactionId]);

  const fetchTickets = useCallback(
    async (page = 1, pageSize = 10) => {
      setLoading(true);
      try {
        const params = buildParams();

        const res = await api.get_ticket_list({
          ...params,
          page,
          limit: pageSize,
        });

        if (res.status === 200) {
          // =========================
          // ✅ DATA TAARUULAH ХЭСЭГ
          // =========================

          // Variant A: res.data = { data: [], total: number }
          const itemsA = res.data?.data;
          const totalA = res.data?.total;

          // Variant B: res.data = { data: { items: [], total: number } }
          const itemsB = res.data?.data?.items;
          const totalB = res.data?.data?.total;

          const items = Array.isArray(itemsA)
            ? itemsA
            : Array.isArray(itemsB)
              ? itemsB
              : [];

          const total = Number(
            typeof totalA === "number"
              ? totalA
              : typeof totalB === "number"
                ? totalB
                : 0,
          );

          setTickets(items);
          setPagination((prev) => ({
            ...prev,
            current: page,
            pageSize,
            total,
          }));
        } else {
          toast(res.data?.message || "Алдаа гарлаа", "error");
        }
      } catch (e) {
        toast(e?.response?.data?.message || "Серверийн алдаа", "error");
      } finally {
        setLoading(false);
      }
    },
    [buildParams, toast],
  );

  // ✅ modal нээгдэхэд reset
  useEffect(() => {
    if (!visible) return;

    setTickets([]);
    setHasSearched(false);

    setPhone("");
    setPrefix("");
    setBankNumber("");
    setTransactionId("");

    setPagination({ current: 1, pageSize: 10, total: 0 });
  }, [visible]);

  const handleSearch = () => {
    setHasSearched(true);
    fetchTickets(1, pagination.pageSize);
  };

  const handleClear = () => {
    setPhone("");
    setPrefix("");
    setBankNumber("");
    setTransactionId("");

    setTickets([]);
    setHasSearched(false);
    setPagination((p) => ({ ...p, current: 1, total: 0 }));
  };

  const handleSelect = (record) => {
    setSelectedTicket?.(record);
    onClose?.();
  };

  const columns = [
    {
      title: "Prefix",
      dataIndex: ["Lottery", "ticket_prefix"],
      key: "ticket_prefix",
    },
    // { title: "Ticket ID", dataIndex: "id", key: "id" },
    {
      title: "Утас",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Үнийн дүн",
      key: "amount",
      render: (_, record) => {
        const firstPayment = record.Payments?.[0]?.amount;
        const invoiceAmount = record.Invoice?.amount;
        const val = firstPayment ?? invoiceAmount ?? 0;
        return formatCurrency(Number(val));
      },
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "";
        let label = "";

        switch (status) {
          case "canceled":
            color = "red";
            label = "Цуцлагдсан";
            break;
          case "paid":
            color = "#0066cc";
            label = "Төлсөн";
            break;
          case "pending":
            color = "orange";
            label = "Хүлээгдэж байна";
            break;
          default:
            color = "gray";
            label = status;
        }

        return <span style={{ color, fontWeight: 500 }}>{label}</span>;
      },
    },
    {
      title: "Сугалаа авсан огноо",
      dataIndex: "created_at",
      key: "created_at",
      width: 160,
      render: (val) => formatDateTime(val) || "",
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          style={{ fontSize: 12 }}
          onClick={() => handleSelect(record)}
        >
          Сонгох
        </Button>
      ),
    },
  ];

  return (
    <CustomModal
      open={visible}
      title="Ticket сонгох"
      onCancel={onClose}
      footer={null}
      width={980}
    >
      <Flex vertical gap={12}>
        <Space style={{ marginBottom: 16 }} wrap>
          <CustomInput
            placeholder="Утасны дугаар"
            value={phone}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/\D/g, "");
              if (onlyNums.length <= 8) setPhone(onlyNums);
            }}
            style={{ width: 170 }}
            maxLength={8}
            type="number"
          />

          <CustomInput
            placeholder="Prefix"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value)}
            style={{ width: 140 }}
          />

          <CustomInput
            placeholder="Дансны дугаар"
            value={bankNumber}
            onChange={(e) => setBankNumber(e.target.value)}
            style={{ width: 180 }}
            type="number"
          />

          <CustomInput
            placeholder="ID ..."
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            style={{ width: 180 }}
          />

          <Button
            size="large"
            icon={<IconSearch size={14} />}
            onClick={handleSearch}
            disabled={!hasQuery}
          >
            Хайх
          </Button>

          <Divider type="vertical" />

          <Button size="large" onClick={handleClear}>
            Цэвэрлэх
          </Button>
        </Space>

        {!hasSearched ? (
          <Empty
            description="Хайлт хийнэ үү"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            style={{ padding: "24px 0" }}
          />
        ) : (
          <Table
            rowKey={(r) => r.id}
            columns={columns}
            dataSource={tickets}
            loading={loading}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              onChange: (p, ps) => fetchTickets(p, ps),
            }}
            size="middle"
          />
        )}
      </Flex>
    </CustomModal>
  );
};

export default TicketModal;
